import React, { useState } from "react";
import { toast } from "sonner";
import { SearchCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const monthsAgo = (n) => { const d = new Date(); d.setMonth(d.getMonth() - n); return d.toISOString().slice(0, 10); };

export function DetailedCheckCard({ techs, running, onStarted }) {
  const [techId, setTechId] = useState("");
  const [includeRead, setIncludeRead] = useState(true);
  const [reprocess, setReprocess] = useState(false);
  const [since, setSince] = useState(monthsAgo(6));
  const [busy, setBusy] = useState(false);

  const start = async () => {
    if (!techId) { toast.error("Scegli il tecnico da controllare"); return; }
    setBusy(true);
    try {
      await api.post("/mail-serials/run", { technician_ids: [techId], include_read: includeRead, since, reprocess });
      toast.success("Controllo dettagliato avviato");
      onStarted();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Avvio non riuscito"); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-sm border border-slate-200 bg-white p-6" data-testid="mail-detailed-card">
      <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Controllo dettagliato</div>
      <p className="mt-1 text-xs text-slate-500">
        Ricontrolla le mail di un tecnico anche se sono già state aperte in Gmail (fino a 12 mesi fa). Le mail già elaborate dal software vengono saltate, a meno che non spunti "Ricontrolla": in quel caso le rilegge e registra solo i seriali nuovi (quelli già registrati vengono scartati).
      </p>
      <div className="mt-4 flex flex-wrap items-end gap-4">
        <label className="text-sm">
          <span className="mb-1 block text-xs font-semibold text-slate-600">Tecnico</span>
          <Select value={techId} onValueChange={setTechId}>
            <SelectTrigger className="h-10 w-64 rounded-sm" data-testid="mail-detailed-tech-select"><SelectValue placeholder="Scegli tecnico" /></SelectTrigger>
            <SelectContent>
              {techs.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`mail-detailed-tech-${t.id}`}>{t.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </label>
        <label className="text-sm">
          <span className="mb-1 block text-xs font-semibold text-slate-600">Dal</span>
          <Input type="date" value={since} min={monthsAgo(12)} onChange={(e) => setSince(e.target.value)} className="w-44" data-testid="mail-detailed-since" />
        </label>
        <label className="flex items-center gap-2 pb-2 text-sm font-semibold text-slate-700">
          <Checkbox checked={includeRead} onCheckedChange={(v) => setIncludeRead(!!v)} data-testid="mail-detailed-include-read" />
          Leggi anche le mail già lette
        </label>
        <label className="flex items-center gap-2 pb-2 text-sm font-semibold text-slate-700">
          <Checkbox checked={reprocess} onCheckedChange={(v) => setReprocess(!!v)} data-testid="mail-detailed-reprocess" />
          Ricontrolla anche le mail già elaborate (es. foto HEIC)
        </label>
        <Button onClick={start} disabled={busy || running} className="rounded-sm bg-slate-900 hover:bg-slate-800" data-testid="mail-detailed-start-btn">
          <SearchCheck className="mr-2 h-4 w-4" /> Avvia controllo
        </Button>
      </div>
    </div>
  );
}
